/**
 * Plain data with no imports, so the browser bundle pays for the data alone
 * and the contract generator can read it before the files it writes exist.
 *
 * @module platform/graphql-enum-values
 */

/**
 * The domain value each GraphQL name stands for, per enum.
 *
 * Keyed by enum name, then by GraphQL name. That is the direction
 * `makeExecutableSchema` wants, and it is also the direction a client reading a
 * payload wants, which is why one map serves both.
 */
export const enumValues: Record<string, Record<string, string>> = {
  // Paging vocabulary rather than a domain value, so its name is its value.
  // Listed anyway because makeExecutableSchema takes the whole map and an enum
  // missing from it would be the one that silently kept GraphQL's default.
  OrderDirection: {
    ASC: "ASC",
    DESC: "DESC",
  },
  // Read off the SDL by the type generator, never carried by a field.
  ScopeKind: {
    PROGRAMME: "PROGRAMME",
    TENANT: "TENANT",
    SESSION: "SESSION",
    PLATFORM: "PLATFORM",
    NONE: "NONE",
  },
  ProgrammeOrderField: {
    TITLE: "TITLE",
    UPDATED_AT: "UPDATED_AT",
    WORKFLOW_STATE: "WORKFLOW_STATE",
    NFQ_LEVEL: "NFQ_LEVEL",
    MODULE_COUNT: "MODULE_COUNT",
  },
  TenantOrderField: {
    NAME: "NAME",
    CREATED_AT: "CREATED_AT",
    STATUS: "STATUS",
  },
  UserOrderField: {
    EMAIL: "EMAIL",
    DISPLAY_NAME: "DISPLAY_NAME",
    ACCOUNT_ROLE: "ACCOUNT_ROLE",
  },
  AuditEventOrderField: {
    TIMESTAMP: "TIMESTAMP",
  },
  ExportOrderField: {
    TIMESTAMP: "TIMESTAMP",
  },
  ResponsibilityOrderField: {
    RESPONSIBILITY: "RESPONSIBILITY",
    USER_ID: "USER_ID",
  },
  ModuleOwnerOrderField: {
    MODULE_ID: "MODULE_ID",
    USER_ID: "USER_ID",
  },
  AssignedModuleOrderField: {
    PROGRAMME_TITLE: "PROGRAMME_TITLE",
    MODULE_TITLE: "MODULE_TITLE",
    UPDATED_AT: "UPDATED_AT",
  },
  ReviewRoundOrderField: {
    ROUND_NUMBER: "ROUND_NUMBER",
    CREATED_AT: "CREATED_AT",
  },
  NotificationOrderField: {
    CREATED_AT: "CREATED_AT",
  },
  WorkflowState: {
    DRAFT: "Draft",
    READY_FOR_DEVELOPMENT: "Ready for Development",
    IN_DEVELOPMENT: "In Development",
    AWAITING_INTERNAL_REVIEW: "Awaiting Internal Review",
    INTERNAL_REVIEW: "Internal Review",
    CHANGES_REQUIRED: "Changes Required",
    AWAITING_QA_APPROVAL: "Awaiting QA Approval",
    APPROVED: "Approved",
    FINAL_DESCRIPTOR_SIGNED_OFF: "Final Descriptor Signed Off",
    EXPORTED_AND_LOCKED: "Exported and Locked",
    ARCHIVED: "Archived",
  },
  VisibilityState: {
    SANDBOX: "sandbox",
    OFFICIAL: "official",
    LOCKED: "locked",
  },
  DeliveryStatus: {
    ACTIVE: "active",
    INACTIVE: "inactive",
  },
  AccountRole: {
    CLIENT_ADMIN: "client-admin",
    MEMBER: "member",
  },
  ResponsibilityKind: {
    LEAD: "lead",
    BUILDER: "builder",
    REVIEWER: "reviewer",
    APPROVER: "approver",
    VIEWER: "viewer",
    READER: "reader",
  },
  FindingSeverity: {
    BLOCKING: "blocking",
    ADVISORY: "advisory",
  },
  PublicationIssueSeverity: {
    BLOCKING: "blocking",
    WARNING: "warning",
  },
  FindingStatus: {
    OPEN: "open",
    RESOLVED: "resolved",
  },
  AmendmentStatus: {
    PROPOSED: "proposed",
    APPROVED: "approved",
    REJECTED: "rejected",
    WITHDRAWN: "withdrawn",
  },
  AmendmentClassification: {
    ADMINISTRATIVE: "administrative",
    MINOR: "minor",
    MAJOR: "major",
  },
  CurriculumRevisionKind: {
    INITIAL: "initial",
    AMENDMENT: "amendment",
    REVALIDATION: "revalidation",
  },
  RevisionLifecycleStatus: {
    APPROVED_FUTURE: "approved-future",
    CURRENT: "current",
    SUPERSEDED: "superseded",
  },
  PublicationStatusKind: {
    INTERNAL: "internal",
    SCHEDULED: "scheduled",
    ELIGIBLE: "eligible",
    ENDED: "ended",
  },
  CurriculumChangeCaseKind: {
    AMENDMENT: "amendment",
    REVALIDATION: "revalidation",
  },
  CurriculumChangeCaseStatus: {
    TEAM_CONFIRMATION: "team-confirmation",
    OPEN: "open",
    SUBMITTED: "submitted",
    AWAITING_APPROVAL: "awaiting-approval",
    CHANGES_REQUIRED: "changes-required",
    APPROVED: "approved",
    REPLACEMENT_CREATED: "replacement-created",
    REJECTED: "rejected",
    WITHDRAWN: "withdrawn",
  },
  ExportFormat: {
    DESCRIPTOR: "descriptor",
    SCHEDULE: "schedule",
    JSON: "json",
  },
};
